import React, { memo } from 'react';
import { View, FlatList } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { PreviewGalleryPostCard } from '@redlink/components/muscles';
import { useValues } from '@redlink/assets/values';
import { useNavigation } from '@react-navigation/native';

export const PreviewResumeProjects = memo(
  ({ title, data = {}, style, pageName, scrollContainerStyle }) => {
    const { styles } = useStyle();
    const { navigate } = useNavigation();
    const { routes } = useValues();

    return (
      <View style={[styles.container, style]}>
        {title && <Text style={styles.text}>{title}</Text>}
        <FlatList
          horizontal
          {...{ data }}
          keyExtractor={({ id }) => `${id}`}
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={[styles.projects, scrollContainerStyle]}
          ItemSeparatorComponent={() => <Space size={8} />}
          renderItem={({ item }) => (
            <PreviewGalleryPostCard
              {...{ item }}
              style={styles.featuredProjectsStyle}
              smallTile
              onPress={() =>
                navigate(routes.previewPostDetail.key, {
                  pageName,
                  shortLink: item.shortLink,
                })
              }
            />
          )}
        />
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {},
  text: {
    fontSize: 16,
    color: colors.title,
    fontWeight: 'bold',
    marginBottom: 8,
    paddingHorizontal: 24,
  },
  featuredProjectsStyle: {
    width: 192,
    height: 256,
  },
  projects: {
    paddingHorizontal: 24,
  },
}));
